<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title"><span *ngIf="data.SkillOrTraining === 'S'">Skill Detail: </span><span *ngIf="data.SkillOrTraining === 'T'">Training Detail: </span>{{data.CodeDescription}}</h3>
</div>

<div class="modal-body">
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Date Taken: </strong></label> {{data.DateCertifiedDisplay}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Date Expires: </strong></label> {{data.DateExpiresDisplay}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;" *ngIf="!hideGrade">
        <div class="col-lg-12">
            <label><strong>Grade: </strong></label> {{data.Grade}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Status: </strong></label> {{data.Status}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Employee: </strong></label> {{data.EmployeeName}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Description: </strong></label> {{data.CodeDescription}}
        </div>
    </div>
    <div class="row" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Note: </strong></label> {{data.Notes}}
        </div>
    </div>
    <div class="row" *ngIf="data.SkillOrTraining === 'S'" style="margin-bottom:10px;">
        <div class="col-lg-12">
            <label><strong>Skill Tester: </strong></label> {{data.SkillTesterName}}
        </div>
    </div>
    <div *ngIf="data.SkillOrTraining === 'T'" style="margin-bottom:10px;">
        <div class="row">
            <div class="col-lg-3">
                <label><strong>OSHA</strong></label>
                <input class="ml-1" type="checkbox" [(ngModel)]="data.OSHAYN" trueFalseValue trueValue="Y" falseValue="N" disabled="disabled" />
            </div>
            <div class="col-lg-3">
                <label><strong>MSHA</strong></label>
                <input class="ml-1" type="checkbox" [(ngModel)]="data.MSHAYN" trueFalseValue trueValue="Y" falseValue="N" disabled="disabled" />
            </div>
            <div class="col-lg-3">
                <label><strong>First Aid</strong></label>
                <input class="ml-1" type="checkbox" [(ngModel)]="data.FirstAidYN" trueFalseValue trueValue="Y" falseValue="N" disabled="disabled" />
            </div>
            <div class="col-lg-3">
                <label><strong>CPR</strong></label>
                <input class="ml-1" type="checkbox" [(ngModel)]="data.CPRYN" trueFalseValue trueValue="Y" falseValue="N" disabled="disabled" />
            </div>
            <div class="col-lg-12">
                <label><strong>Work Related</strong></label>
                <input class="ml-1" type="checkbox" [(ngModel)]="data.WorkRelatedYN" trueFalseValue trueValue="Y" falseValue="N" disabled="disabled" />
            </div>
        </div>
    </div>
    <label *ngIf="savedFiles.length > 0 && data.HasAttachments"><strong>Attachments</strong></label>
    <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
        <a href="/Document/GetVCMAttachment?contentTypeName={{file.VCMContentType}}&docID={{file.VCMDocID}}&filename={{file.Description}}" *ngIf="file.VCMDocID != null">{{file.Description}}</a>
        <a href="/Document/GetVPAttachment?attachmentID={{file.AttachmentID}}" *ngIf="file.VCMDocID == null"> {{file.Description}}</a>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>